module.exports = __webpack_public_path__ + "img/om.88e9ece1.svg";